import angular from 'angular';

angular.module('cloudX').directive('cxCurrencyTypeahead', [
  '$filter',
  '$rootScope',
  'dataCache',
  function($filter, $rootScope, dataCache) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div class="dropdown" uib-dropdown ng-show="options.length" is-open="ddwOpen">' +
        ' <div class="input-group">' +
        '     <input type="text" ng-model="selected" uib-typeahead="item as item.label for item in options | filter:$viewValue | orderBy:[\'-common\',\'+label\'] | limitTo:limit " typeahead-min-length="0" typeahead-select-on-blur="selectOnBlur" typeahead-select-on-exact="selectOnExact" typeahead-on-select="onSelect($item)" ng-blur="onBlur()" ng-focus="ddwOpen=false" class="form-control" placeholder="{{placeholder}}" autocomplete="off"/>' +
        '     <span class="input-group-btn">' +
        '         <button class="btn btn-default dropdown-toggle btn-font-14" uib-dropdown-toggle>' +
        '             <span class="caret"></span>' +
        '         </button>' +
        '     </span>' +
        ' </div>' +
        ' <ul class="dropdown-menu" role="menu" style="max-height:200px;overflow-y:auto">' +
        '     <li ng-repeat="op in options | filter:{common:true} | orderBy:[\'label\']" ng-class="{\'selected\':op===selected}"><a href ng-click="onSelect(op)">{{op.label}}</a></li>' +
        '     <li role="separator" class="divider"></li>' +
        '     <li ng-show="showAll" ng-repeat="op in options | orderBy:[\'+label\']" ng-class="{\'selected\':op===selected}"><a href ng-click="onSelect(op)">{{op.label}}</a></li>' +
        '     <li ng-hide="showAll"><a href ng-click="showAll=true; $event.stopPropagation();"><span data-translate>Show all</span></a></li>' +
        ' </ul>' +
        '</div>',
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        var options = dataCache.getArray('currency');
        $scope.limit = $scope.$eval(attrs.limit) || 10;
        $scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
          ? $scope.$eval(attrs.selectOnBlur) || attrs.selectOnBlur
          : true;
        $scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
          ? $scope.$eval(attrs.selectOnExact) || attrs.selectOnExact
          : true;
        $scope.showAll = false;

        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el.id === code;
          });
        };

        var mapOptions = function() {
          $scope.placeholder = $filter('translateList')(null, 'currency');
          $scope.options = options.map(function(c) {
            return {
              id: c.code,
              label: c.code + ' - ' + $filter('translateList')(c.code, 'currency', c.name),
              common: c.isCommon,
            };
          });
          $scope.selected = findOption($scope.value);
        };

        mapOptions();
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);

        $scope.onSelect = function(item) {
          $scope.selected = item;
          $scope.value = item.id;
          ngModel.$setViewValue(item.id);
        };
        $scope.onBlur = function() {
          if ($scope.selected != null && $scope.selected.id != null) return;
          $scope.value = null;
          $scope.selected = null;
          ngModel.$setViewValue(null);
        };

        ngModel.$render = function() {
          $scope.value = ngModel.$viewValue;
          $scope.selected = findOption($scope.value);
        };
      },
    };
  },
]);
